import { connect } from 'react-redux'
import { IGlobalState } from '../../../../Root/store/appReducer'
import {
  joinCompany,
  getUserCompanyCountries,
  getCompanyDivisions,
  setUserDivision,
  setUserCountry,
  setJoinedCompanyId,
  updateUserCompanyProfile,
} from '../../store/SettingsActions'
import JoinAnotherCompany, { IJoinCompanyProps, IJoinCompanyDispatchProps } from './JoinAnotherCompany'
import {
  userDtoSelector,
  getJoinCompanyLoading,
  companyCountriesSelector,
  companyDivisionsSelector,
  getJoinedCompanyId,
  getUserCompanyProfileLoading,
} from '../../store/SettingsSelectors'
import { getUserCompanies } from '../../../../common/auth/authSelectors'
import {
  getCreatedDivisionId,
  getDivisionCategories,
  //getDivisionsSelectorDeprecated,
} from '../../../TeamManagement/store/TeamManagementSelectors'
import {
  setCreatedDivisionId,
  getDivisionCategories as getDivisionCategoriesAction,
  //getDivisionsDeprecated as getDivisionsAction,
  setUserCategoryDivision,
} from '../../../TeamManagement/store/TeamManagementActions'
import { getNotification } from '../../../../common/notifications/NotificationSelectors'
import { INotification } from '../../../../common/notifications/NotificationReducers'

/**
 * Connects the JoinCompany component to Redux state
 * Provides data and actions related to joining companies
 * and setting up user's team and country
 */
const mapStateToProps = (state: IGlobalState, ownProps: Partial<IJoinCompanyProps>) => ({
  ...ownProps,
  userId: userDtoSelector(state).userId,
  joinCompanyLoading: getJoinCompanyLoading(state),
  userCompanyProfileLoading: getUserCompanyProfileLoading(state),
  countries: companyCountriesSelector(state),
  divisions: companyDivisionsSelector(state),
  joinedCompanyId: getJoinedCompanyId(state),
  userCompanies: getUserCompanies(state),
  createdDivisionId: getCreatedDivisionId(state),
  notification: getNotification(state),
  divisionCategories: getDivisionCategories(state) || [],
  //companyGroups: getDivisionsSelectorDeprecated(state) || {},
})

const mapDispatchToProps: IJoinCompanyDispatchProps = {
  joinCompany,
  setUserDivision,
  setUserCountry,
  setJoinedCompanyId,
  setCreatedDivisionId,
  updateUserCompanyProfile,
  getDivisionCategories: getDivisionCategoriesAction,
  getDivisions: getCompanyDivisions,
  setUserCategoryDivision,
}

export default connect(mapStateToProps, mapDispatchToProps)(JoinAnotherCompany)
